import { KiteIcon } from '@kite/react-kite';
import React from 'react';
import FocusTrapReact from 'focus-trap-react';
import './MediaLibraryVideoPlayer.scss';

export interface MediaLibraryVideoPlayerProps {
    videoFile: string;
    title: string;
    duration: string;
    filesize: string;
    setVideoOpen: React.Dispatch<
        React.SetStateAction<MediaLibraryVideoPlayerProps>
    >;
}
export const MediaLibraryVideoPlayer = (
    props: MediaLibraryVideoPlayerProps
) => {
    return (
        <FocusTrapReact>
            <section
                aria-modal={true}
                className="media-library-video-player"
                tabIndex={0}
            >
                <header>
                    <div>
                        <h2>{props.title}</h2>
                        <p>
                            <span>{props.duration}</span>
                            <span>
                                {Math.round(
                                    Number.parseInt(props.filesize) / 10000
                                ) / 100}
                                {` `}
                                mb
                            </span>
                        </p>
                    </div>
                    <a
                        href={props.videoFile}
                        download
                        className="kite-button"
                        aria-label={`Download ${props.title} Video`}
                    >
                        Download Video
                    </a>
                </header>
                <div className="video-container">
                    <video title={props.title} controls>
                        <source src={props.videoFile} />
                    </video>
                </div>
                <button
                    className="close-button"
                    aria-label="Close modal"
                    onClick={() => props.setVideoOpen(null)}
                >
                    <KiteIcon icon="ki-x" />
                </button>
            </section>
        </FocusTrapReact>
    );
};
